import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { getCurrentYear } from "../../../../components/scheduler/calendar/utils";
import classes from "./styles.module.scss";

export const AuthPageDesktop = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.imageBackground}></div>

      <div className={classes.layout}>
        <div className={classes.leftSide}>
          <div className={classes.overlay}>
            <div className={classes.overlayText}>
              {(() => {
                const text = t("trainingMotivation");
                const parts = text.split(", ");
                return parts.map((part, index) => (
                  <span key={index}>
                    {part}
                    {index === 1 ? (
                      <br />
                    ) : index < parts.length - 1 ? (
                      ", "
                    ) : (
                      ""
                    )}
                  </span>
                ));
              })()}
            </div>
          </div>
        </div>
        <div className={classes.rightSide}>
          <div className={classes.formWrapper}>
            {children || <Outlet />}
            <div className={classes.copyright}>
              <Typography component="span" className={classes.copyrightText}>
                © {getCurrentYear()} YNA LLC. All rights reserved
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
